import React from "react";
import Slider from "../../components/Slider/Slider";
import Navbar from "../../components/navbar/Navbar";

const Homepage1 = () => {
  return (
    <div className="homepage1">
      <Navbar />
      <Slider />
    </div>
  );
};

export default Homepage1;
